module.exports = __webpack_public_path__ + "Panton-SemiBold.03c475814000.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Panton-SemiBold.eot
// module id = ./src/styles/fonts/Panton-SemiBold.eot
// module chunks = 21